import { render, staticRenderFns } from "./TicketScreen.vue?vue&type=template&id=10e21a67&scoped=true&"
import script from "./TicketScreen.vue?vue&type=script&lang=ts&"
export * from "./TicketScreen.vue?vue&type=script&lang=ts&"
import style0 from "./TicketScreen.vue?vue&type=style&index=0&id=10e21a67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e21a67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
